import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { DeereFetch } from '../../shared/fetch';

import { HistoryStatuses } from '../HistoryStatuses';

export class HistoryDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            opened: false,
            history: []
        };

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }

    async componentDidUpdate(prevProps, prevState) {
        if (this.state.opened !== prevState.opened && this.state.opened) {
            this.setState({
                loading: true
            });

            try {
                if (this.props.quote) {
                    this.setState({
                        history: await DeereFetch(`/api/quotes/${this.props.quote.id}/history`),
                        historyElementNumber: this.props.quote.quoteNumber
                    });
                } else if (this.props.thirdParty) {
                    this.setState({
                        history: await DeereFetch(`/api/third-parties/${this.props.thirdParty.id}/history`),
                        historyElementNumber : this.props.thirdParty.number
                    });
                } else {
                    this.setState({
                        history: []
                    });
                }
            } finally {
                this.setState({
                    loading: false
                });
            }
        }
    }

    open() {
        this.setState({
            opened: true
        });
    }

    close() {
        this.setState({
            opened: false
        });
    }

    render() {
        return (
            <div>
                <Button color="primary" onClick={this.open} variant="outlined">History</Button>
                <Dialog
                    aria-labelledby="history-dialog-title"
                    onClose={this.close}
                    open={this.state.opened}
                    scroll="paper">
                    <DialogTitle id="history-dialog-title">Status History {this.state.historyElementNumber}</DialogTitle>
                    <DialogContent dividers>
                        {!this.state.loading && (
                            <div>
                                {this.state.history && this.state.history.length > 0 ? (
                                    <HistoryStatuses history={this.state.history} thirdParty={!!this.props.thirdParty} />
                                ) : (
                                    <div>No History Available</div>
                                )}
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" onClick={this.close}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
